// removed by extract-text-webpack-plugin
module.exports = {"hidden":"_3XRjJ","visuallyhidden":"_3TNuC","hide-text":"_Pc-A","center":"O9TS_","noprint":"_37gkM","root":"_2_3Kb","text":"_1ShmS"};


/*****************
 ** WEBPACK FOOTER
 ** ./~/@spp/ui-blockquote/styles/Blockquote_Factbox.scss
 ** module id = 936
 ** module chunks = 1
 **/